export default "__VITE_ASSET__DQnB4Qvw__"